module.exports = __webpack_public_path__ + "static/img/hxrs-xq.167afd9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/hxrs-xq.png
// module id = QpSN
// module chunks = 0